(function () {
    'use strict';

    var module = angular.module('uwAgenda.search');
    module.factory('SearchService', ['$http', ResourcesServiceFn]);

    /* search service */
    function ResourcesServiceFn($http) {
        var baseUrl = '/api/search/';
        var service = {
            searchAppointments: searchAppointments,
            searchZipCodes: searchZipCodes,
            searchTasks: searchTasks,
            searchPatients: searchPatients
        };

        return service;

        /* search appointments */
        function searchAppointments(userId, agendaId, searchValue) {
            if (searchValue === null) { return; }

            return $http({
                url: baseUrl + userId + '/' + agendaId+'/appointments',
                method: 'GET',
                params: {
                    searchValue: searchValue
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* search appointments */
        function searchTasks(userId, agendaId, searchValue) {
            if (searchValue === null) { return; }

            return $http({
                url: baseUrl + userId + '/' + agendaId+'/tasks',
                method: 'GET',
                params: {
                    searchValue: searchValue
                }
            }).then(function (response) {
                return response;
            });
        }


        /* fulltextsearch of zip codes and locations */
        function searchZipCodes(searchValue) {
            return $http({
                url: baseUrl + 'zipcodes',
                method: 'GET',
                params: {
                    searchValue: searchValue
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* search patients */                            
        function searchPatients(userId, searchValue, birthday) {
            return $http({
                url: baseUrl + 'patients/' + userId,
                method: 'GET',
                params: {
                    searchValue: searchValue,
                    birthday: birthday
                }
            }).then(function (result) {
                return result.data;
            });
        }

    }
})();